import request from '@/service/index'

export const getCountryList = () => {
  return request({
    url: '/common/getCountrys',
    method: 'GET'
  })
}

export const getCountryTableData = (params: any) => {
  return request({
    url: '/common/GetPhonePart',
    method: 'GET',
    params
  })
}
